module.exports = __webpack_public_path__ + "img/1.5a2b313a.png";